import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeliveryMethodsSkeleton = () => {
  return (
    <Styles.Container>
      <Skeleton variant="rounded" width="100%" height={64} />
      <Skeleton variant="rounded" width="100%" height={64} />
    </Styles.Container>
  )
}

export default DeliveryMethodsSkeleton
